import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (credentials) => {
    setLoading(true);
    try {
      console.log('Sending credentials:', credentials);
      const apiUrl = process.env.REACT_APP_API_URL;
      console.log('API URL:', apiUrl);

      const response = await fetch(`${apiUrl}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: credentials.username,
          password: credentials.password
        })
      });

      const data = await response.json();
      console.log('Response:', data);

      if (!response.ok) {
        throw new Error(data.message || 'Login failed');
      }

      const token = typeof data.token === 'object' ? data.token.token : data.token;
      const userData = { 
        ...data.user, 
        token };

      console.log('Auth token:', token);
      if (!token || typeof token !== 'string') {
        throw new Error('Invalid or missing authentication token');
      }
      setUser(userData);
      localStorage.setItem('authToken', token);
      localStorage.setItem('userData', JSON.stringify(userData)); // Store user info

      return { success: true, data: userData };
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
  };

  const checkAuth = () => {
    const token = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('userData');

    if (token && storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
    }
    setLoading(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};


